import React, { FC, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import { Context } from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsContext'
import AcquiringSettlementsTableRow from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsTableRow'
import { useStyles } from 'components/core/Acquiring/AcquiringSettlements/components/styles'

const SettlementsTable: FC = () => {
    const style = useStyles()
    const { t } = useTranslation()
    const { loader, settlements } = useContext(Context)

    return (
        <Grid container spacing={3}>
            <Grid item md={12} lg={12} className="verticalScrollable">
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table" className={style.tableContainer}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" padding="normal">
                                    {t('Acquiring.SettledFor')}
                                </TableCell>
                                <TableCell align="left">{t('Acquiring.TotalCharges')}</TableCell>
                                <TableCell align="left">{t('Acquiring.TotalRefunds')}</TableCell>
                                <TableCell align="left">{t('Acquiring.TotalChargebacks')}</TableCell>
                                <TableCell align="right" padding="normal">
                                    {t('Acquiring.Amounts')}
                                </TableCell>
                                <TableCell align="right" padding="normal">
                                    {t('Acquiring.Details')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loader?.GET_CARD_ACQUIRING_SETTLEMENTS ? (
                                <TableRow>
                                    <TableCell>{t('Acquiring.LoadingSettlements')}</TableCell>
                                </TableRow>
                            ) : !settlements?.records?.length ? (
                                <TableRow>
                                    <TableCell>{t('Acquiring.NoResults')}</TableCell>
                                </TableRow>
                            ) : (
                                !!settlements.records &&
                                settlements.records?.map((record: ParsedRecord, i: number) => (
                                    <AcquiringSettlementsTableRow key={i} record={record} />
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

export default SettlementsTable
